<template>

	<div class="bkf7 goods_detail" style="padding-top: 20px;margin-top: 0;">
		<el-container>



			<div class="inter">
				<el-row>
					<div class="wdiv1">
						<div class="image">

							<div v-show="loading">
								<el-skeleton style="width: 450px">
									<template slot="template">
										<el-skeleton-item variant="image" style="width: 450px; height: 350px;" />
									</template>
								</el-skeleton>
							</div>


							<el-image :src="goods.image" :preview-src-list="info.banner" v-show="!loading"></el-image>
						</div>
						<div class="text">
							<div v-show="loading">
								<el-skeleton :rows="3" animated />
							</div>

							<el-tooltip popper-class="custom-tooltip" effect="dark" :content="goods.title"
								placement="top-end">
								<h1 class="p1" style="position: relative;">{{ goods.title }}

									<div class="zhankai">
										<div class="ic">
											<img :src="require(`@/assets/image/zhankai.png`)"
												style="display: block;width: 14px;">
										</div>
										展开
									</div>

								</h1>
							</el-tooltip>


							<div class="p2">

								<div class="views t-flex t-flex-items-center">
									<div class="item t-flex t-flex-items-center" style="margin-right: 10px;">
										<i class="el-icon-view" style="font-size: 25px;margin-right: 5px;"></i>
										{{ goods.views }}
									</div>
									<div class="item" @click="shoucang">
										<div class="like" v-if="type == 0">
											<img :src="require(`@/assets/image/like1.png`)"
												style="display: block;width: 25px;">
										</div>
										<div class="like" v-if="type == 1">
											<img :src="require(`@/assets/image/like2.png`)"
												style="display: block;width: 25px;">
										</div>
									</div>
								</div>
							</div>
							<div class="n_text">
								<div v-show="loading">
									<el-skeleton :rows="3" animated />
								</div>
								<div class="n_p1 t-flex t-flex-items-center" v-show="!loading">
									<div class="t-flex t-flex-items-center" style="margin-right: 10px;">
										<el-tooltip class="item" effect="dark" :content="'被找回无法追回赔付' + goods.price"
											placement="top-end">
											<div>
												售价&nbsp;:&nbsp;<span class="price">{{ goods.price }}</span>
											</div>
										</el-tooltip>

									</div>



									<div class="t-flex t-flex-items-center" v-if="goods.fuwufei <= 0">
										<!-- <el-tooltip class="item" effect="dark"
											:content="'最高赔付上限' + goods.price * 2" placement="top-end">
											<div>
												可买充值包赔，最高赔付上限&nbsp;:&nbsp;
												<span class="price">{{ goods.price * 2 }}</span>
											</div>
										</el-tooltip> -->

										<div>
											充值包赔，最高三倍赔付，手续费&nbsp;:&nbsp;
											<span class="price">{{ shouxufei }}</span>
										</div>
									</div>
									<div class="t-flex t-flex-items-center" v-if="goods.fuwufei > 0">


										<div>
											服务费&nbsp;:&nbsp;
											<span class="price">{{ goods.fuwufei }}</span>
										</div>
									</div>
								</div>
								<div class="n_p1 t-flex t-flex-items-center" v-if="goods.is_zu == 1" v-show="!loading">
									<div class="t-flex t-flex-items-center" style="margin-right: 10px;">
										租号价格&nbsp;:&nbsp;<span class="text-F7423F">{{ goods.zuhao_price }}</span>
									</div>

								</div>
								<div class="n_p2" v-show="!loading">
									<span>商品编号&nbsp;:&nbsp;<label>H610{{ goods.id }}</label></span>
									<span>上架时间&nbsp;:&nbsp;<label>{{ goods.updatetime }}</label></span>
								</div>
								<div class="n_p2" v-show="!loading">
									<span>游戏区服&nbsp;:&nbsp;<label>{{ daqu.text }}</label></span>

								</div>

							</div>
							<div class="p4 t-flex t-flex-items-center t-flex-between">

								<div class="tags_img" v-if="goods && goods.bq_text">
									<el-tag v-for="(item, index) in goods.bq_text" effect="dark"
										v-if="item != '找回包赔' && item != ''">
										{{ item }}
									</el-tag>
									<el-tag v-for="(item, index) in goods.bq_text" effect="blue"
										v-if="item == '找回包赔' && item != ''">
										{{ item }}
									</el-tag>

									<el-tag v-if="goods.is_zu == 1" effect="dark">
										可租
									</el-tag>
									<el-tag effect="red" v-if="goods.status == 'normal'">


										<a style="color: #fff;" @click="openKefu">在线咨询</a>




									</el-tag>
									<el-tag effect="red" v-if="goods.status != 'normal'">
										<a style="color: #fff;"
											href="https://tb.53kf.com/code/client/696ac86f721b23bfe7eb4b6e24f45b349/1"
											target="_blank">商品已成交</a>
									</el-tag>

								</div>

								<div class="tags_img">
									<el-tag effect="red" @click="addOrder" v-if="goods.status == 'normal'">
										立即购买
									</el-tag>

								</div>

							</div>

						</div>
					</div>
				</el-row>
				<el-row>
					<div class="wdiv3">
						<div class="n_de_ti" style="margin-top: 10px;">商品描述</div>
						<div class="show_ti">
							<span class="sp1" v-if="goods && goods.channel">
								{{ goods.channel.name }}
							</span>
							<span class="sp2" v-if="goods && goods.title">
								{{ goods.title }}
							</span>
						</div>
						<div v-show="loading">
							<el-skeleton :rows="3" animated />
						</div>
					</div>
				</el-row>


				<el-row>
					<div class="wdiv2">
						<el-tabs class="gs_tabls" type="border-card">
							<el-tab-pane label="图文详情">

								<div v-show="loading">
									<el-skeleton :rows="10" animated />
								</div>

								<div class="t-flex t-flex-center" style="padding: 30px 10%;">
									<div class="con goods_show_con">
										<img v-for="item in goods.images" :src="'https://img.h6ds.com/' + item"
											style="display: block;margin: 0 auto;" />
										<div v-html="goods.content">

										</div>
									</div>
								</div>
							</el-tab-pane>
							<el-tab-pane label="包赔介绍">

								<div class="con goods_show_con" v-if="baopei && baopei.archivesInfo"
									v-html="baopei.archivesInfo.content">

								</div>

							</el-tab-pane>
							<el-tab-pane label="交易流程">
								<div class="con goods_show_con" v-if="jiaoyi && jiaoyi.archivesInfo"
									v-html="jiaoyi.archivesInfo.content">

								</div>
							</el-tab-pane>
							<el-tab-pane label="联系客服">

								<div class="n_de_ti">微信客服</div>

								<div class="kefu_list">
									<div class="item" v-for="item in kefu">
										<div class="con">
											<div class="image">
												<el-image :src="img_url + item.image" lazy></el-image>
											</div>
											<div class="text">
												<p class="p1">{{ item.name }}</p>
												<p class="p2">工作时间:{{ item.time }}</p>
											</div>
										</div>

									</div>
								</div>
								<div class="n_de_ti">QQ群</div>
								<div class="kefu_list">
									<div class="item" v-for="item in qun">
										<a class="con" :href="item.url" target="_blank">
											<div class="image">
												<el-image :src="img_url + item.image" lazy></el-image>
											</div>
											<div class="text">
												<p class="p1">{{ item.name }}</p>
												<p class="p2">
													<span>跳转加群</span>
												</p>
											</div>
										</a>

									</div>
								</div>

							</el-tab-pane>
						</el-tabs>
					</div>
				</el-row>


			</div>

		</el-container>
	</div>

</template>
<script>
import {
	Notification,
	Message
} from 'element-ui'
export default {
	data() {
		return {
			goods: {},
			goods_id: 0,
			loading: true,
			info: {},
			daqu: {},
			baopei: {},
			jiaoyi: {},
			kefu: [],
			qun: [],
			type: 0,
			shouxufei: 0,


		}
	},
	created: function (data) {

		this.goods_id = this.$route.query.id

		if (this.goods_id == undefined) {
			this.goods_id = this.$route.params.id
		}




		this.getDetail(this.goods_id);
		this.getBaopei();
		this.getJiaoyi()
		this.getKefu()
		this.getQun()
		this.getCollect()

	},
	watch: {
		$route() {

		}
	},
	methods: {
		openKefu(){
			api_kefu.push('cmd','comeinfo');
			api_kefu.push('title',this.goods.title);
			api_kefu.push('logo',this.goods.image);
			api_kefu.push('content',this.goods.title);
			api_kefu.push('curl','http://www.h6ds.com/goodsdetail?id='+this.goods.id);

			api_kefu.query();

			api_kefu.push('cmd', 'kfclient');
			api_kefu.push('type', 'new');
			api_kefu.query();
		},
		addOrder() {
			this.$router.push('/addorder?id=' + this.goods.id)
		},
		getDetail(id) {
			var that = this;
			this.rq.requests.post("api/hall/ArchivesDetail", {
				id: id,
			}).then(res => {

				that.info = res.data;
				that.goods = res.data.archives;
				that.shouxufei = parseFloat(that.goods.price * 0.1).toFixed(0)
				that.daqu = res.data.daqu;
				that.loading = false;

			}).catch(error => {

			})
		},
		getBaopei() {
			var that = this;
			this.rq.requests.post("addons/cms/wxapp.Archives/detail2", {
				id: 81992,
			}).then(res => {
				that.baopei = res.data;

			}).catch(error => {

			})
		},
		getJiaoyi() {
			var that = this;
			this.rq.requests.post("addons/cms/wxapp.Archives/detail2", {
				id: 549051,
			}).then(res => {
				that.jiaoyi = res.data;

			}).catch(error => {

			})
		},

		getKefu() {
			var that = this;
			this.rq.requests.post("api/Wxapp/sellKefu", {}).then(res => {
				that.kefu = res.data;

			}).catch(error => {

			})
		},

		shoucang() {
			var that = this;


			var logined = Boolean(localStorage.getItem('usertoken'))

			if (!logined) {
				this.$router.push('/login')
				return;
			}

			this.rq.requests.post("api/Wxapp/pullCollect", {

				id: that.goods_id,
				type: that.type

			}).then(res => {

				if (that.type == 0) {
					that.type = 1;

					Message.success({
						message: "收藏成功",
						duration: 3000
					})
				} else {
					that.type = 0;
					Message.success({
						message: "已取消",
						duration: 3000
					})
				}

			}).catch(error => {

			})

		},

		getCollect() {
			var that = this;
			this.rq.requests.post("api/Wxapp/getCollect", {
				id: this.goods_id

			}).then(res => {

				if (res.data.status == 1) {
					that.type = 1;
				}


			}).catch(error => {

			})
		},

		getQun() {
			var that = this;
			this.rq.requests.post("api/Wxapp/qun", {}).then(res => {
				that.qun = res.data;

			}).catch(error => {

			})
		},

	}
}
</script>
<style>
.zuhao .el-radio__input {
	display: flex !important;
	align-items: center;
}

.zuhao .el-radio__input.is-checked .el-radio__inner {
	border-color: #fe6730;
	background: #fe6730;
}

.zuhao .el-radio__input.is-checked+.el-radio__label {
	color: #fe6730;
}
</style>